import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface ErrorState {
	displayGlobalError: boolean;
}

const initialState: ErrorState = {
	displayGlobalError: false,
};

export const errorSlice = createSlice({
	name: 'ErrorSlice',
	initialState,
	reducers: {
		setDisplayGlobalError: (state, action: PayloadAction<boolean>) => {
			const displayGlobalError = action.payload;

			return {
				...state,
				displayGlobalError,
			};
		},
	},
});

export const { setDisplayGlobalError } = errorSlice.actions;
export default errorSlice.reducer;
